import Util from 'app/util'

import getters from './games/getters.js'
import mutations from './games/mutations.js'
import actions from './games/actions.js'

export default {

	namespaced: true,

	state: {

		name: 'ratings',

		route: 'Ratings',

		data: Util.filter.templates.ratings(),

		defaultValues: Util.filter.templates.ratings(),

		preset: 0,

		changed: false

	},
	
	getters: getters,
	mutations: mutations,
	actions: actions

}